import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d830bc8")

_pushScopeId("data-v-5d830bc8")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "line-green" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("button", {
    class: ["green-button", { disabled: _ctx.disabled }],
    disabled: _ctx.disabled
  }, [
    _hoisted_1,
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 10, ["disabled"]))
})